"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./IconButton.scss");
var _classnames = _interopRequireDefault(require("../../../utils/classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconButton = function IconButton(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    secondary = _ref.secondary,
    large = _ref.large,
    active = _ref.active;
  var classes = (0, _classnames["default"])({
    secondary: secondary,
    active: active,
    large: large
  });
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: id,
    className: 'uin-icon-btn ' + classes,
    onClick: onClick,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(large ? 'large' : '', " ").concat(icon)
  }));
};
IconButton.propTypes = {
  id: _propTypes["default"].string,
  icon: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  large: _propTypes["default"].bool
};
var _default = exports["default"] = IconButton;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/IconButton/IconButton.js
// module id = 257
// module chunks = 0